import { useState } from 'react';
import { CorporationService } from '../../services/corporation/corporationService';

/*----------------------------------------------------------------------------------------
* EN: Hook to manage corporations fetching and transformation logic.
* ES: Hook para gestionar la lógica de obtención y transformación de empresas.
----------------------------------------------------------------------------------------*/

const useCorporations = (initialFilters = {}) => {

    const [data, setData] = useState<any[]>([]);
    const filters = {
        limit: 200,
        filter_filters: { ...initialFilters }
    };

    const fetchCorporations = async (f: any) => {
        const newFilters = { ...filters, filter_filters: { ...filters.filter_filters, ...f } };
        try {
            const response = await (new CorporationService()).listCorporationsForSelect(newFilters);
            const fetchedData = response.getResponseData()?.data;

            if (fetchedData && fetchedData?.data) {
                const mappedData = fetchedData.data?.map((data: { id: string; name: string; corporation_function?: string; }) => ({
                    value: data.id,
                    label: data.name,
                    corporationFunction: data.corporation_function,
                }));
                setData(mappedData);
                return mappedData;
            }
        } catch (error) {
            console.log('Error fetching corporations:', error);
        }
    };

    const getCorporationsList = () => {
        return data;
    };

    return { fetchCorporations, getCorporationsList };
}

export default useCorporations;